/** 한글 음절(가~힣)에서 초성(ㄱ~ㅎ, 쌍자음 포함) */
const CHOSEONG = [
  "ㄱ",
  "ㄲ",
  "ㄴ",
  "ㄷ",
  "ㄸ",
  "ㄹ",
  "ㅁ",
  "ㅂ",
  "ㅃ",
  "ㅅ",
  "ㅆ",
  "ㅇ",
  "ㅈ",
  "ㅉ",
  "ㅊ",
  "ㅋ",
  "ㅌ",
  "ㅍ",
  "ㅎ",
] as const;

const CHOSEONG_SET = new Set<string>(CHOSEONG);

function choseongFromSyllableCode(code: number): string {
  if (code < 0xac00 || code > 0xd7a3) return "";
  const idx = Math.floor((code - 0xac00) / 588);
  return CHOSEONG[idx] ?? "";
}

/** 문자열에서 한글 음절별 초성만 이어 붙임(영문·숫자 등은 생략) */
function hangulChoseongSequence(text: string): string {
  let out = "";
  for (const ch of text) {
    const code = ch.codePointAt(0)!;
    if (code >= 0xac00 && code <= 0xd7a3) {
      out += choseongFromSyllableCode(code);
    }
  }
  return out;
}

/** 검색어가 초성 자모(ㄱ~ㅎ 계열)만으로 이루어졌는지 */
function isChoseongOnlyQuery(query: string): boolean {
  const q = query.replace(/\s/g, "");
  if (!q) return false;
  for (const ch of q) {
    if (!CHOSEONG_SET.has(ch)) return false;
  }
  return true;
}

/** 대소문자 무시 부분 문자열 일치 */
export function includesIgnoreCase(text: string, query: string): boolean {
  return text.toLowerCase().includes(query.toLowerCase());
}

/**
 * 검색어가 초성 자모만으로 이루어진 경우:
 * 본문의 한글 음절 초성을 이은 문자열에 검색어(공백 제외)가 연속 포함되는지
 */
function matchesChoseongOnlyQuery(text: string, choseongQuery: string): boolean {
  const compact = choseongQuery.replace(/\s/g, "");
  if (!compact) return false;
  return hangulChoseongSequence(text).includes(compact);
}

/**
 * 상품명 검색: 부분 일치(영문·한글 등)를 먼저 적용하고,
 * 해당 없으면 검색어가 초성 자모만일 때 초성 연속 매칭을 시도한다.
 */
export function matchesProductNameSearch(text: string, rawQuery: string): boolean {
  const query = rawQuery.trim();
  if (!query) return true;

  if (includesIgnoreCase(text, query)) return true;

  if (isChoseongOnlyQuery(query)) {
    return matchesChoseongOnlyQuery(text, query);
  }

  return false;
}
